import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Heading, Text, Button, Stack, HStack, Wrap, WrapItem, Icon } from "@chakra-ui/react";
import { Building2, Plane, CircleCheck } from "lucide-react";
import { responsiveBg } from "../../utils/responsiveImage";
import { useLocalPath, useText } from "../../i18n/lang";

// Aceeași imagine ca înainte: e preîncărcată din public/index.html (LCP)
const HERO_IMAGE = "https://www.travel-time.ro/images/newImages/shutterstock_1022824408.jpg";

const TEXT = {
  en: {
    title: "Travel Time, the leading airline ticketing consolidator",
    subtitle:
      "Corporate travel management, MICE events and the Booking Time B2B platform for travel agencies. IATA accredited, in business since 2005.",
    companies: "For companies",
    agencies: "For travel agencies",
    trust: ["IATA accredited", "ISO 9001 & ISO 14001", "ANAT member", "24/7 support"],
  },
  ro: {
    title: "Travel Time, principalul consolidator de bilete de avion",
    subtitle:
      "Managementul călătoriilor de afaceri, evenimente corporate (MICE) și platforma B2B Booking Time pentru agenții de turism. Agent acreditat IATA, din 2005.",
    companies: "Pentru companii",
    agencies: "Pentru agenții de turism",
    trust: ["Acreditare IATA", "ISO 9001 și ISO 14001", "Membru ANAT", "Suport 24/7"],
  },
};

const HomeHero = () => {
  const t = useText(TEXT);
  const localPath = useLocalPath();
  const toTop = () => window.scrollTo(0, 0);

  return (
    <Box as="header" position="relative" backgroundImage={responsiveBg(HERO_IMAGE)} backgroundSize="cover" backgroundPosition="center">
      {/* Imaginea rămâne vizibilă, dar textul are contrast */}
      <Box
        position="absolute"
        inset={0}
        bgGradient="linear(100deg, rgba(8, 24, 48, 0.94) 0%, rgba(11, 31, 58, 0.82) 45%, rgba(11, 31, 58, 0.35) 100%)"
      />
      <Container maxW="container.xl" position="relative" pt={{ base: 14, md: 24 }} pb={{ base: 28, md: 36 }} color="white">
        <Stack spacing={6} maxW="3xl" align={{ base: "center", md: "flex-start" }} textAlign={{ base: "center", md: "left" }}>
          <Heading
            as="h1"
            fontFamily="Montserrat"
            fontWeight="700"
            fontSize={{ base: "3xl", md: "5xl", lg: "6xl" }}
            lineHeight="1.12"
            letterSpacing="tight"
          >
            {t.title}
          </Heading>

          <Text fontSize={{ base: "lg", md: "xl" }} color="blue.50" lineHeight="1.6" maxW="2xl">
            {t.subtitle}
          </Text>

          <Stack direction={{ base: "column", sm: "row" }} spacing={4} w={{ base: "full", sm: "auto" }} pt={2}>
            <Button
              as={RouterLink}
              to={localPath("/servicii")}
              onClick={toTop}
              size="lg"
              h="56px"
              px={8}
              colorScheme="orange"
              bg="orange.400"
              _hover={{ bg: "orange.500", transform: "translateY(-2px)", boxShadow: "xl" }}
              leftIcon={<Building2 size={20} />}
              transition="all 0.2s"
            >
              {t.companies}
            </Button>
            <Button
              as={RouterLink}
              to={localPath("/agentii-partenere")}
              onClick={toTop}
              size="lg"
              h="56px"
              px={8}
              variant="outline"
              color="white"
              borderColor="whiteAlpha.700"
              _hover={{ bg: "whiteAlpha.200" }}
              leftIcon={<Plane size={20} />}
            >
              {t.agencies}
            </Button>
          </Stack>

          <Wrap spacing={{ base: 3, md: 5 }} justify={{ base: "center", md: "flex-start" }} pt={2}>
            {t.trust.map((item) => (
              <WrapItem key={item}>
                <HStack spacing={2} color="blue.50">
                  <Icon as={CircleCheck} boxSize={5} color="green.300" />
                  <Text>{item}</Text>
                </HStack>
              </WrapItem>
            ))}
          </Wrap>
        </Stack>
      </Container>
    </Box>
  );
};

export default HomeHero;
